//ブックコピー画面
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Draggable, { DraggableData, DraggableEvent } from 'react-draggable';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button, List, ListItem, ListItemText, ListItemIcon } from '@material-ui/core';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';

import { CardTemplateAttributeDb } from '../redux/cardTemplateAttributeDbSlice';
import { CardAttributeDb, CardAttributeDbHashType } from '../redux/cardAttributeDbSlice';
import { deepCopy } from '../general';
import { EditTemplateAttributeDbHashType } from '../components/EditTemplateDialog';

type ItemListItemProps = {
  dragging: boolean;
}
const ItemListItem = styled(ListItem)<ItemListItemProps>`
  position: absolute;
  transition: ${props => props.dragging ? undefined : '300ms'};
`

type ChangeAttributeOrderDialogProps = {
  open: boolean;
  onClose: () => void;
  attributeIds: string[];
  attributes: EditTemplateAttributeDbHashType | CardAttributeDbHashType;
  setAttributes: (attributes: any) => void;
}
const ChangeAttributeOrderDialog: React.FC<ChangeAttributeOrderDialogProps> = ({open, onClose, attributeIds, attributes, setAttributes}) => {
  const [stateAttributes, setStateAttributes] = useState(attributes);
  const [draggingId, setDraggingId] = useState('');

  useEffect(() => setStateAttributes(attributes), [open])

  const changeOrder = (data: DraggableData, targetId: string, targetItem: CardTemplateAttributeDb | CardAttributeDb) => {
    if (!stateAttributes) return;
    const newAttributes = deepCopy(stateAttributes);
    const startOrder = targetItem.order;
    const endOrder = Math.round(data.y / 48);
    if (startOrder < endOrder) {
      attributeIds.forEach(id => {
        const attribute = stateAttributes[id];
        if (!attribute) return;
        if (id === targetId) newAttributes[id] = {...attribute, order: endOrder};
        else if (startOrder < attribute.order && attribute.order <= endOrder) {
          newAttributes[id] = {...attribute, order: attribute.order - 1};
        }
      })
      setStateAttributes(newAttributes);
    } else if (startOrder > endOrder) {
      attributeIds.forEach(id => {
        const attribute = stateAttributes[id];
        if (!attribute) return;
        if (id === targetId) newAttributes[id] = {...attribute, order: endOrder};
        if (endOrder <= attribute.order && attribute.order < startOrder) {
          newAttributes[id] = {...attribute, order: attribute.order + 1};
        }
      })
      setStateAttributes(newAttributes);
    }
  }
  const changeAttributeOrderExe = () => {
    setAttributes(stateAttributes);
    onClose();
  }
  const cansel = () => {
    setStateAttributes(attributes);
    if (stateAttributes !== attributes) setTimeout(onClose, 400);
    else onClose();
  }

  return (
    <Dialog open={open} onClose={cansel}  maxWidth="xs">
      <DialogTitle>入力アイテムの表示順序を指定します</DialogTitle>
      <DialogContent style={{overflow: 'auto', height: attributeIds.length * 48}}>
        <List component="nav">
          { attributeIds.map(id => {
            const attribute = stateAttributes ? stateAttributes[id] : undefined;
            if (!attribute) return undefined;
            return (
              <Draggable position={{x: 0, y: attribute.order * 48}} handle=".handle"
                onStart={() => setDraggingId(id)}
                onDrag={(ev: DraggableEvent, data: DraggableData) => changeOrder(data, id, attribute)}
                onStop={() => setDraggingId('')}
                axis="y" bounds={{top: 0, bottom: (attributeIds.length - 1) * 48}}>
                <ItemListItem button key={id} dragging={id === draggingId}>
                  <ListItemIcon className="handle">
                    <DragIndicatorIcon />
                  </ListItemIcon>
                  <ListItemText primary={attribute.name} key={attribute.name} />
                </ItemListItem>
              </Draggable>
            );
          }) }
        </List>
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={cansel}>
          キャンセル
        </Button>
        <Button color='primary' onClick={changeAttributeOrderExe}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ChangeAttributeOrderDialog;
